import { render } from "./PHONE_NUMBER_INPUT.vue?vue&type=template&id=558471d8"
import script from "./PHONE_NUMBER_INPUT.vue?vue&type=script&lang=js"
export * from "./PHONE_NUMBER_INPUT.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-kiosk\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__